module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "introduction"
    }
  }, [_c('h1', [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.93194in",
      "height": "4.06491in"
    },
    attrs: {
      "alt": "",
      "src": "media/file0.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('em', [_vm._v("Thirteen Months of Sunshine")]), _vm._v(" is a book based on the detailed diaries I kept while placed in northern Ethiopia by the Voluntary Service Overseas. My time there covered a year spanning 2012 and 2013. The Education Department where I was based really appreciates the support given by VSO. Ethiopians realise that in order to progress as a nation they need to educate their population, and developing a modern, national education system is a massive undertaking. Although VSO does an amazing job preparing volunteers for such work, in reality, I left England knowing very little about Ethiopia, so this is a record of much of my year of my learning and if I am honest, my survival!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a654880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 75
// module chunks = 0